<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Assign To User</p>
    </header>
    <section class="modal-card-body">
      <b-table
        :columns="columns"
        :data="tableData"
        :selected.sync="selected"
      ></b-table>
    </section>
    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$parent.close()">
        Cancel
      </button>
      <button
        class="button is-info"
        type="button"
        :disabled="!canAssign"
        @click="assign(selected.username)"
      >
        Assign
      </button>
      <div class="spacer"></div>
      <button class="button is-warning" type="button" @click="unassign">
        Unassign
      </button>
    </footer>
  </div>
</template>

<script>
import isEmpty from "lodash/isEmpty";
import { SnackbarProgrammatic as Snackbar } from "buefy";
import ui from "@/store/modules/ui";

export default {
  props: {
    reloadTable: Function
  },
  data() {
    return {
      columns: [
        {
          field: "username",
          label: "Username"
        }
      ],
      selected: {}
    };
  },
  computed: {
    canAssign() {
      // if no rows are selected, return false
      return !isEmpty(this.selected);
    },
    checkedImageIds() {
      return this.$store.state.ui.checkedImageRows.map(r => r.name);
    },
    tableData() {
      return ui.users.map(username => ({
        username
      }));
    }
  },
  methods: {
    async assign(username) {
      try {
        await ui.assignImagesToUsers({
          userId: username,
          imageIds: this.checkedImageIds
        });
        // reload table
        await this.reloadTable();
        ui.setCheckedImageRows([]);
      } catch (error) {
        // server access failed
        console.error(error);
        Snackbar.open({
          message: "Accessing the server failed.",
          actionText: "Close",
          type: "is-warning",
          indefinite: true,
          position: "is-top"
        });
      } finally {
        this.$parent.close();
      }
    },
    async unassign() {
      await this.assign("");
    }
  },
  async mounted() {
    await ui.fetchUsers();
  }
};
</script>

<style lang="scss" scoped>
.modal-card-foot {
  display: flex;
  flex-direction: row;
}
.spacer {
  flex: 1 0 0;
}
</style>
